import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { MandateApproveListData } from 'api/nach';
import MandateActionColumn from '../components/MandateActionColumn';
// import { maskAllDigitsExceptLastFour } from 'features/nach/utils/maskNumber';
// import DashboardActionColumn from '../components/ActionColumn';

const FilterApprovrovedColumn: ColumnsType<MandateApproveListData> = [
  {
    key: 'mandateId',
    title: 'Mandate Request ID',
    dataIndex: 'mandateId',
    fixed: 'left',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'loanNo',
    title: 'Loan Number',
    dataIndex: 'loanNo',
    // fixed: 'left',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'sourceApplicationName',
    title: 'Source Application Name',
    dataIndex: 'sourceApplicationName',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'mandateStatus',
    title: 'Mandate Status',
    dataIndex: 'mandateStatus',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'mandateRemark',
    title: 'Approve Mandate Remark',
    dataIndex: 'mandateRemark',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'View',
    title: 'Action',
    dataIndex: 'View',
    ellipsis: true,
    width: 400,
    align: 'center',
    render: (_, record) => (
      <span
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        <MandateActionColumn record={record} />
      </span>
    ),
  },
];

export default FilterApprovrovedColumn;
